import { r as registerInstance, c as createEvent, h, H as Host } from './index-662ec80e.js';
import { c as currentLocale, t } from './i18n-939e2dee.js';
import { p as propCheck, r as runWatchers, h as hasPropError, d as displayPropError } from './propCheck-e7571e3e.js';
import { a1 as vUndefOr, a as vString, l as vEmail, O as vInteger, K as vMinNumber, B as vEmpty, p as vEthereumAddress } from './validation-02b8d01d.js';

const dsUserMenuCss = "ds-user-menu{display:block;position:relative}ds-user-menu .menu-toggle{position:relative;cursor:pointer}ds-user-menu .menu-toggle ds-eth-avatar,ds-user-menu .menu-toggle ds-icon{position:absolute}ds-user-menu .avatar-stack{position:absolute;top:0;left:0}ds-user-menu .avatar-stack ds-icon{position:absolute;bottom:0;right:0}ds-user-menu .avatar-stack ds-icon+ds-icon{bottom:2px;right:2.25px}ds-user-menu .menu-container{position:absolute;background-color:white;display:none;min-width:15rem;border-radius:var(--radius);box-shadow:var(--shadow-1);margin:0.5rem;z-index:8000}ds-user-menu .menu-container.active{display:block}ds-user-menu .menu-header{display:block;margin-bottom:1rem;border-top-left-radius:var(--radius);border-top-right-radius:var(--radius);width:100%;background-color:var(--grey-400);padding:1rem;white-space:nowrap}ds-user-menu .menu-footer{display:block;margin-top:1rem !important;width:100%;text-align:right;padding:1rem !important}";

const DsUserMenu = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.signOut = createEvent(this, "signOut", 7);
    this.propError = {};
    this.currentLocale = currentLocale();
    this.name = undefined;
    this.email = undefined;
    this.avatarSize = 32;
    this.wallet = undefined;
    this.isOpen = false;
  }
  // istanbul ignore next
  updateLocale() {
    this.currentLocale = currentLocale();
  }
  watchName() {
    /* istanbul ignore if */
    if (!propCheck(this, 'name', 'string', vUndefOr(vString)))
      return;
  }
  watchEmail() {
    /* istanbul ignore if */
    if (!propCheck(this, 'email', 'string', vEmail))
      return;
  }
  watchAvatarSize() {
    /* istanbul ignore if */
    if (!propCheck(this, 'avatarSize', 'number', v => vInteger(v) || vMinNumber(1)(v)))
      return;
  }
  watchWallet() {
    /* istanbul ignore if */
    if (!propCheck(this, 'wallet', 'string', vUndefOr(v => vEmpty(v) && vEthereumAddress(v))))
      return;
  }
  onToggleMenu() {
    this.isOpen = !this.isOpen;
  }
  onSignOut() {
    this.signOut.emit();
  }
  matchCurrentOrClosest(el, selector) {
    if (el.matches(selector))
      return el;
    else
      return el.closest(selector);
  }
  handleClick(e) {
    if (!this.isOpen)
      return;
    const target = e.target;
    if (!this.matchCurrentOrClosest(target, '.menu-toggle'))
      this.isOpen = false;
  }
  connectedCallback() {
    runWatchers(this);
    this.updateLocale();
  }
  render() {
    if (hasPropError(this))
      return displayPropError(this);
    return (h(Host, { style: { width: this.avatarSize + 'px', height: this.avatarSize + 'px' } }, h("div", null, h("div", { class: "menu-toggle", onClick: () => this.onToggleMenu() }, this.wallet ?
      h("ds-eth-avatar", { size: this.avatarSize, address: this.wallet })
      :
        h("ds-icon", { name: "user", size: this.avatarSize + 'px', color: "var(--grey-600)" }), h("div", { class: "avatar-stack", style: { width: this.avatarSize + 'px', height: this.avatarSize + 'px' } }, h("ds-icon", { name: "point", size: "0.75rem", color: "var(--black)", class: "_p:left(2) _p:top(1)" }), h("ds-icon", { name: "down-open", size: "0.4rem", color: "var(--grey-100)", class: "_p:left(2) _p:top(1)" }))), h("div", { class: `menu-container ${this.isOpen ? 'active' : null}`, style: { top: this.avatarSize + 'px', right: '-' + this.avatarSize + 'px' } }, h("div", { class: "menu-header" }, this.name ?
      h("div", null, h("div", { class: "_text:sm" }, this.name), h("div", { class: "_text:xs _text-grey-900" }, this.email))
      :
        h("div", { class: "_text:sm" }, this.email)), h("div", { onClick: () => this.onToggleMenu() }, h("slot", null)), h("div", { class: "menu-footer" }, h("ds-button", { label: t('userMenu.signOut'), onClick: () => this.onSignOut() }))))));
  }
  static get watchers() { return {
    "name": ["watchName"],
    "email": ["watchEmail"],
    "avatarSize": ["watchAvatarSize"],
    "wallet": ["watchWallet"]
  }; }
};
DsUserMenu.style = dsUserMenuCss;

export { DsUserMenu as ds_user_menu };
